export const OBJECT_STATUS = {
  PUBLISHED_TER_SCHEME: 'published_ter_scheme',
  DRAFT: 'draft',
  SIMPLE: 'simple',
};
